import { HubSheet, HubSheetActions } from "../AdminPortal/HubPwa";
import s from "../clinic.module.css";

function clientEmail(client) {
  const email = String(client?.email || "").trim().toLowerCase();
  if (!email || email.includes("@patient.internal")) return null;
  return email;
}

export default function RegistrationModerationSheet({
  open,
  onClose,
  client,
  status,
  busy = false,
  onConfirm,
}) {
  if (!client) return null;

  const isApprove = status === "approved";
  const title = isApprove ? "Подтвердить заявку" : "Отклонить заявку";
  const email = clientEmail(client);

  return (
    <HubSheet open={open} onClose={busy ? undefined : onClose} title={title}>
      {isApprove ? (
        <div className={s.registrationModerationSheet}>
          <p className={s.registrationModerationLead}>
            <strong>{client.full_name}</strong> получит доступ в клиентский портал.
          </p>
          <ul className={s.registrationModerationList}>
            <li>На email из заявки придёт ссылка для создания пароля</li>
            <li>После входа — расписание, абонементы и новости клуба</li>
          </ul>
          {email ? (
            <p className={s.registrationModerationEmail}>
              Письмо с активацией: <strong>{email}</strong>
            </p>
          ) : (
            <p className={s.registrationModerationWarn}>
              Email не указан — активация не отправится. Добавьте email в карточке
              клиента и отправьте приглашение вручную.
            </p>
          )}
        </div>
      ) : (
        <p className={s.registrationModerationLead}>
          Заявка <strong>{client.full_name}</strong> будет отклонена. Клиент не
          сможет войти в портал.
        </p>
      )}

      <HubSheetActions
        primary={busy ? "…" : isApprove ? "Подтвердить" : "Отклонить"}
        secondaryLabel="Отмена"
        onSecondary={onClose}
        primaryDisabled={busy}
        onPrimary={onConfirm}
        primaryType="button"
      />
    </HubSheet>
  );
}
